<template>
    <div class="repair-box">
        <!-- 标题 -->
        <center-title>{{$t("message.service.menu1")}}</center-title>
        <div class="repair-content">
            <el-tabs
                v-model="activeName"
                @tab-click="handleClick">
                <!--  -->
               <el-tab-pane
                    :label="$t('message.repair.tabs1')"
                    name="1">
                    <repair-form
                        :handle-submit="handleSubmitRepair">
                    </repair-form>
                </el-tab-pane>
                <!--  -->
                <el-tab-pane
                    :label="$t('message.repair.tabs2')"
                    name="2">
                    <repair-table></repair-table>
                </el-tab-pane>
            </el-tabs>
        </div>
        <!-- 模态框 -->
       <user-agreement v-if="activeName == 1"></user-agreement>
        <repair-dialog v-else></repair-dialog>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    data() {
        return {
            activeName: "1",
        }
    },
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        repairForm: () => import("@/components/service/repairForm"),
        repairTable: () => import("@/components/service/repairTable"),
        repairDialog: () => import("@/components/service/repairDialog"),
        userAgreement: () => import("@/components/agreement")
    },
    methods: {
        ...mapActions([
            "getServiceGoods",
            "getRepairList",
            "handleSubmitRepair"
        ]),
        handleClick(tab, event){
            switch (tab.name) {
                case "1":
                    break;
                case "2":
                    this.getRepairList()
                    break;
            }
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.getServiceGoods()
        })
    }
}
</script>

<style scoped>
.repair-content{
    padding: 0px 20px;
    background-color: #fff;
}
</style>